// src/pages/buyer/PersonalizationPage.jsx
// Phase 2 — M2: Buyer recommendations + recently viewed

import { useEffect, useState } from 'react'
import { personalizationApi } from '../../api/services'

function ProductGrid({ title, products, loading, emptyMsg }) {
  if (loading) return <div style={{ color: '#9CA3AF', textAlign: 'center', padding: 40 }}>Loading…</div>
  if (!products.length) return (
    <div style={{ color: '#9CA3AF', textAlign: 'center', padding: 40, fontSize: '0.88rem' }}>{emptyMsg}</div>
  )
  return (
    <div>
      <h2 style={{ fontFamily: 'Playfair Display, serif', fontWeight: 800, fontSize: '1.2rem', color: '#1A1A2E', margin: '0 0 18px' }}>{title}</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16 }}>
        {products.map(p => (
          <a key={p.id} href={`/catalogue/product/${p.slug}`} style={{ textDecoration: 'none' }}>
            <div style={{ background: '#fff', borderRadius: 14, border: '1.5px solid #F0F0F0', overflow: 'hidden', transition: 'box-shadow 0.2s' }}>
              <div style={{ height: 140, background: '#F9FAFB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem' }}>
                {p.primaryImage?.url ? <img src={p.primaryImage.url} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : '🧵'}
              </div>
              <div style={{ padding: '12px 14px' }}>
                <p style={{ fontWeight: 700, color: '#1A1A2E', margin: '0 0 4px', fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</p>
                <p style={{ color: '#FF3D7F', fontWeight: 800, margin: 0, fontSize: '0.9rem' }}>₹{p.retail_price?.toLocaleString('en-IN')}</p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}

export default function PersonalizationPage() {
  const [recs, setRecs]     = useState([])
  const [viewed, setViewed] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    Promise.all([personalizationApi.recommendations(), personalizationApi.recentlyViewed()])
      .then(([rRes, vRes]) => {
        setRecs(rRes.data?.data ?? [])
        setViewed(vRes.data?.data ?? [])
      }).finally(() => setLoading(false))
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 36 }}>
      <div>
        <h1 style={{ fontFamily: 'Playfair Display, serif', fontWeight: 800, fontSize: '1.8rem', color: '#1A1A2E', margin: '0 0 4px' }}>Picked For You</h1>
        <p style={{ color: '#9CA3AF', margin: 0, fontSize: '0.88rem' }}>Personalised recommendations based on your browsing and order history</p>
      </div>
      <ProductGrid title="Recommended For You" products={recs} loading={loading} emptyMsg="No recommendations yet — browse some products to get started." />
      {viewed.length > 0 && <ProductGrid title="Recently Viewed" products={viewed} loading={false} emptyMsg="" />}
    </div>
  )
}
